interface Props {
  active: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

export function Chip({ active, children, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full px-3.5 py-2 text-[13px] font-semibold whitespace-nowrap ${
        active
          ? 'border border-navy bg-navy text-cream shadow-bt'
          : 'bt-flat border border-line bg-paper text-ink-soft'
      }`}
    >
      {children}
    </button>
  );
}
